import { Link, useLocation } from 'react-router-dom';
import { SearchResult } from '../../api/api';
import { useLazyGetCasesQuery } from '../../api/apiService';
import { Tab } from '../../api/configsApi';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Autocomplete from '../../features/autocomplete/Autocomplete';
import { setSearchResult } from '../../features/search-result/searchResultSlice';

function Navs({ expanded }: { expanded: boolean }) {
  const configId = useAppSelector((state) => state.config?.id);
  const config = useAppSelector((state) => state.config);
  const tabs = useAppSelector((state) => state.config?.tabs);
  const { pathname } = useLocation();
  const [getCases] = useLazyGetCasesQuery();
  const dispatch = useAppDispatch();

  function onSelect(data: SearchResult) {
    if (!configId)
      return;
    getCases({ searchResult: data, configId });
    dispatch(setSearchResult(data));
  }

  if (expanded || !pathname.includes('reflex')) return null;
  return (
    <h5 className="d-flex align-items-center g-1">
      {(['map', 'cases', 'population', 'property'].some((x) => pathname.includes(x)) && config) &&
        <Autocomplete size="small" width="15.5rem" onSelect={onSelect} />
      }
      {tabs?.includes(Tab.Map) &&
        <Link className="text-decoration-none text-secondary ml-2" to="/reflex/map">
          Karta
        </Link>
      }
      {tabs?.includes(Tab.Cases) &&
        <Link className="text-decoration-none text-secondary" to="/reflex/cases">
          Ärenden
        </Link>
      }
      {tabs?.includes(Tab.Population) &&
        <Link className="text-decoration-none text-secondary" to="/reflex/population">
          Befolkning
        </Link>
      }
      {tabs?.includes(Tab.Property) &&
        <Link className="text-decoration-none text-secondary" to="/reflex/property">
          Fastighet
        </Link>
      }
    </h5>
  );
}

export default Navs;
